import React from "react";
import { Index } from "../components/FooterTexts/InternetAccessInformation/Index";

export const InternetAccessInformation = () => {
  return <Index />;
};
